<template>
  <transition name="page-transition">
    <router-view />
  </transition>
</template>

<script>

export default {
  name: 'Main'
}
</script>

<style scoped lang="less">
.page-transition-enter {
  opacity: 0;
}
.page-transition-leave-active {
  opacity: 0;
}
.page-transition-enter .page-transition-container,
.page-transition-leave-active .page-transition-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
